export default {
  unreadCount: state => state.unreadCount,
  notificationList: state => state.notificationList,
  isNotDisturb: state => state.isNotDisturb,
};
